<script lang="ts">
  import { gql } from '@apollo/client';
  import Paper, { Title, Content } from '@smui/paper';
  import { mutation } from "svelte-apollo";

  import type { ErrorSchema, UserData } from '../types';
  import SignUpForm from '../forms/SignUpForm.svelte';
  import { loginFromResponse } from '../logic/login';

  let formData: UserData;
  let errors: ErrorSchema<UserData> = {
    message: "",
    fields: {
      email: "",
      password: "",
    }
  }

  const registerUser = mutation(gql`
    mutation register($input: RegisterInput!) {
      register(input: $input)
    }
  `);

  async function handleSubmit(event: Event) {
    event.preventDefault();
    try {
      let response: any = registerUser({
        variables: {
          input: {
            displayName: formData.displayName,
            email: formData.email,
            password: formData.password,
          }
        }
      });
      loginFromResponse(response);
    } catch (error) {
      errors["message"] = error.message;
    }
  }
</script>

<div class="paper-container">
  <Paper>
    <Title>Sign Up</Title>
    <Content>
      <SignUpForm submit={handleSubmit} errors={errors} bind:formData/>
    </Content>
  </Paper>
</div>
